import React, { useContext } from "react";
import { Link } from "react-router-dom";
import logo from "../img/logo.svg";
import { Token } from "../Context/AuthContext";

function Nav() {
  // eslint-disable-next-line
  const [auth, setAuth] = useContext(Token);

  //console.log(auth);

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="logo" width="50px" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {!auth && (
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul
                className="navbar-nav"
                style={{
                  marginRight: "100px",
                  marginLeft: "auto",
                }}
              >
                <li className="nav-item">
                  <Link to="/" className="nav-link" aria-current="page">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/about" className="nav-link">
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/contact" className="nav-link">
                    Contact us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin" className="nav-link">
                    Admin Login
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
}

export default Nav;
